import { render, staticRenderFns } from "./AutoDeduction.vue?vue&type=template&id=1a7fcaff&scoped=true&"
import script from "./AutoDeduction.vue?vue&type=script&lang=js&"
export * from "./AutoDeduction.vue?vue&type=script&lang=js&"
import style0 from "./AutoDeduction.vue?vue&type=style&index=0&id=1a7fcaff&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7fcaff",
  null
  
)

export default component.exports